export const REFRESH_CHARTS_DEBOUNCE_MS = 150
export const GET_FILTERS_DEBOUNCE_MS = REFRESH_CHARTS_DEBOUNCE_MS + 150

export const GET_OVERVIEW_DATA_FAILED = 'Problem getting data'
export const GET_DATA_FAILED = 'Problem getting tiles and charts'
export const NO_ANALYSIS_SELECTED = 'No Analysis selected'
export const NO_PROJECT_SELECTED = 'No Project selected'

export const GET_SIGNIFICANT_RESULTS_SUMMARY_TABLE_FAILED =
  'Problem getting significant results summary tables'
export const REFRESH_SIGNIFICANT_RESULTS_SUMMARY_TABLE_FAILED =
  'Problem getting significant results summary tables'
export const GET_STATISTICAL_VALUE_SUMMARY_TABLE_FAILED =
  'Problem getting statistical values summary tables'
export const REFRESH_STATISTICAL_VALUE_SUMMARY_TABLE_FAILED =
  'Problem getting statistical values summary tables'
export const REFRESH_TOP_10_BIGGEST_GAPS_TABLE_FAILED =
  'Problem getting top 10 biggest gaps tables'

export const NEGATIVE_VALUE_TABLE_NOTE = {
  PROMOTIONS:
    'Negative values indicate a group is being promoted less often than expected and positive values indicate a group is being promoted more often than expected.',
  TERMINATIONS:
    'Negative values indicate a group is being terminated more often than expected and positive values indicate a group is being terminated less often than expected.',
}
